<template>
  <Layout>
    <template v-slot:title>No video... yet</template>

    <template v-slot:body>
      <div class="mb-4">
        Athletes with video get 5x more exposure to college coaches.
        Upload unlimited highlight reels and video,
        or embed from YouTube, Hudl, Vimeo and more.
      </div>

      <Button text="Upload Video" @click="trackClick" :short="true"/>
    </template>
  </Layout>
</template>

<script>
import Layout from "../../EmptyStateLayout.vue";
import { Button } from '@sportsrecruits/playbook';
import api from "@/services/api";

export default {
  components: { Button, Layout },
  methods: {
    trackClick() {
      var props = {};
      props.site_access_id = api.clientData('site_access_id');
      props.page = window.location.href;
      props.cta_name = "profile_preview";
      window.SrSegment.track("upload_video_cta", props);
      window.location.assign('/video');
    }
  }
};
</script>